import { render, staticRenderFns } from "./PurchaseTicket.vue?vue&type=template&id=4060c394&scoped=true"
import script from "./PurchaseTicket.vue?vue&type=script&lang=js"
export * from "./PurchaseTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060c394",
  null
  
)

export default component.exports